import { LModalContentsWidthType, ModalType } from '@lib/components';
import { ModalBlockParts } from '@lib/services';
import { SelectMenuComponent } from './select-menu.component';

export interface SelectMenuPayload {
  travelerId?: string;
  flightId?: string;
}

export function selectMenuPayloadParts(payload: SelectMenuPayload): ModalBlockParts {
  return {
    id: 'SelectMenuComponent',
    block: SelectMenuComponent,
    closeBackEnable: false,
    type: ModalType.TYPE4,
    modalWidth: LModalContentsWidthType.NONE,
    payload,
  };
}
